import React from "react";
import { Typography, Grid, Box } from "@mui/material";
import { useResponsive } from "../../hooks/use-responsive";

export default function HeroOne() {

  const mdUp = useResponsive("up", "md");


  return (

    <Grid
      container
      spacing={3}
      sx={{ justifyContent: "center", alignContent: "center" }}
    >
      {mdUp && (
        <Grid item xs={12} md={6}>
          <Typography
            component="span"
            className="HeroHeading"
          >
            SUPERCHARGE YOUR OLD PC WITH &nbsp;<span className="HeroHighlighted"  >CLOUD POWER!</span>
          </Typography>

          <Box justifyContent='center' alignItems='center' mt='28px' >
            <Typography className="heroText" >
              Is your computer slow? Download our app to easily access a fast and powerful cloud PC experience. Just install, log in, and start using your new cloud PC!
            </Typography>
          </Box>

        </Grid>
      )}
      {mdUp && <Grid item xs={12} md={6}>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <img
            src="/assets/home_hero_one.svg"
            alt="home_hero_one"
            style={{ maxWidth: "100%", height: 'auto', objectFit: 'fill' }}

          />
        </Box>
      </Grid>}
      {!mdUp && <Grid item xs={12} md={6}>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <img
            src="/assets/home_hero_one_sm.svg"
            alt="home_hero_one"
            style={{ maxWidth: "100%", height: 'auto', objectFit: 'fill' }}

          />
        </Box>
      </Grid>}
      {!mdUp && (
        <Grid item xs={12} md={7} textAlign="center" >
          <Typography
            component="span"
            className="HeroHeading"
            textAlign={'center'}
          >
            SUPERCHARGE YOUR OLD PC WITH &nbsp;<span className="HeroHighlighted"  >CLOUD POWER!</span>
          </Typography>

          <Box sx={{
            // mt: '18px',
            minHeight: '106px', // Set a minimum height for the Box
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}   >
            <Typography textAlign='center' className="heroText"
            >
              Is your computer slow? Download our app to easily access a fast and powerful cloud PC experience. Just install, log in, and start using your new cloud PC!
            </Typography>
          </Box>
        </Grid>
      )}
    </Grid>
  )
}
